import styles from "./text.module.scss";
import { useMemo } from "react";
import { v4 as uuidv4 } from "uuid";

export const ListText = ({
  backgroundColor = "#fafafa",
  contentsData,
  textAlign = "left",
  style = {},
}: {
  backgroundColor?: string;
  contentsData: {
    title?: string | React.ReactNode;
  }[];
  textAlign?: "left" | "right" | "center";
  style?: React.CSSProperties;
}) => {
  const contentsWithKey = useMemo(() => {
    return contentsData.map((item) => ({
      ...item,
      key: uuidv4(),
    }));
  }, [contentsData]);

  return (
    <>
      <div
        className={`${styles["text"]} ${styles["list"]} ${styles[textAlign]}`}
        style={{
          ...style,
          backgroundColor: backgroundColor,
        }}
      >
        {contentsWithKey.map((content, index) => (
          <div className={styles["text-item"]} key={content.key}>
            <div className={styles["text-contents"]}>
              <div className={styles["text-title"]}>{content.title}</div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};
